import { render, staticRenderFns } from "./Futurefit.vue?vue&type=template&id=4376c6b1"
import script from "./Futurefit.vue?vue&type=script&lang=js"
export * from "./Futurefit.vue?vue&type=script&lang=js"
import style0 from "./Futurefit.vue?vue&type=style&index=0&id=4376c6b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports